import { RootState } from '../store'

export const selectSpecification = (state: RootState) =>
  state.specification.specificationData
export const selectSpecificationLoading = (state: RootState) =>
  state.specification.loading
export const selectSpecificationError = (state: RootState) =>
  state.specification.error
export const selectSpecifications = (state: RootState) => {
  return state.specification.dataSpecifications
}
